import React from "react";
import { PanelField } from "src/components/Form/panels/DefaultFormPanel/PanelField.tsx";
import { useIsFieldHidden } from "src/components/Form/hooks/useIsFieldHidden.ts";

export const FieldRowField = ({ name }: { name: string }) => {
  const { isHidden } = useIsFieldHidden({ name });

  // `name === ""` is treated as a **layout placeholder field**.

  // This placeholder:
  //   is NOT a real form field
  //   mimics the width of the field that would be here
  if (name === "") {
    return <div style={{ flexShrink: 0, flexGrow: 1 }} />;
  }

  if (isHidden) {
    // This avoids layout jumping when fields are conditionally hidden.
    return <div style={{ flexShrink: 0, flexGrow: 1 }} />;
  }

  return <PanelField name={name} />;
};
